window.AW_INVETERATE = window.AW_INVETERATE || {};
document.addEventListener('rebuy:cart.ready', (event) => {
	let checkInterval = setInterval(async () => {
		if (window.inveterate !== undefined && window.inveterate.properties !== undefined && window.inveterate.properties.product !== undefined) {
			clearInterval(checkInterval);

			await inveterateInit();
		}
	}, 300);

	console.log('Cart ready');
	const vipElements = document.querySelectorAll('.add-vip');
	if (vipElements.length > 0) {
		vipElements.forEach(function (element) {
			element.addEventListener('click', function (event) {
				vipElements.forEach(function (element2) {
					element2.classList.add('loading');
				});

				window.Rebuy.Cart.fetchShopifyCart(cart => {
					if (window.Rebuy.Cart.cartHasSubscriptionItems() === false) {
						addVip(event);
					} else {
						document.querySelector('.add-vip').classList.remove('loading');
						document.getElementById('inveterate_switcher').checked = true;
						alert('You already have a subscription item in your cart. Please remove it before adding another one.');
					}
				});
			})
		});
	}
})

document.addEventListener("rebuy:smartcart.line-item-removed", (event) => {
	if (event.detail.item.id === window.AW_INVETERATE.inveterate_product_variant) {
		document.getElementById('inveterate_switcher').checked = false;
	}
});

document.addEventListener('rebuy:cart.add', (event) => {
	if (event.detail.item.id === window.AW_INVETERATE.inveterate_product_variant) {
		document.getElementById('inveterate_switcher').checked = true;
	}
});

document.addEventListener('rebuy:smartcart.show', (event) => {
	initializePopupButtons();
	//initButton();
});

function inveterateInit() {
	window.AW_INVETERATE.inveterate_product_id = window.inveterate.properties.product.id;
	window.AW_INVETERATE.inveterate_product_variant = window.inveterate.properties.product.variants[0].id;
	window.AW_INVETERATE.inveterate_selling_plan = window.inveterate.properties.product.variants[0].selling_plan_allocations[0].selling_plan_id;
	document.querySelectorAll('.inveterate_button').forEach(button => {
		button.classList.add('ready');
	});
}

function addVip(event) {
	event.preventDefault();
	const ButtonType = event.target.getAttribute('data-type');

	return new Promise((resolve, reject) => {
		const Cart = window.Rebuy.Cart;
		const SmartCart = window.Rebuy.SmartCart;
		const CurrentUnixTime = Math.floor(Date.now() / 1000);

		const mainItemId = window.AW_INVETERATE.inveterate_product_variant;
		const mainItemData = {
			id: mainItemId,
			quantity: 1,
			selling_plan: window.AW_INVETERATE.inveterate_selling_plan,
			properties: {
				_inveterate_subscription: true,
				_inveterate__mark: CurrentUnixTime
			},
		};

		const addItemToCart = (itemData) => {
			return new Promise((resolve, reject) => {
				Cart.addItem(itemData, {
					success: (item) => {
						resolve(item);
					},
					error: (err) => {
						reject(err);
					}
				});
			});
		};

		//SmartCart.skip_open = true;

		addItemToCart(mainItemData)
			.then(() => {
				if (ButtonType === 'vip') {
					const current_product_element = document.querySelector('[name="id"]');
					if (current_product_element) {
						const current_product_id = document.querySelector('[name="id"]').value;
						const current_product_qty = document.querySelector('[name="quantity"]').value;

						if (current_product_id && current_product_qty) {
							const additionalItemData = {
								id: current_product_id,
								quantity: current_product_qty,
								properties: {
									_inveterate_discount: 43.99,
									_inveterate__mark: CurrentUnixTime,
									_inveterate__vip: true,
								},
							};

							return addItemToCart(additionalItemData);
						}
					}
				}
			})
			.then(() => {
				SmartCart.show();
				document.querySelector('.add-vip').classList.remove('loading');
				if (window.location.pathname === '/cart') {
					window.location.reload();
				}
				resolve();
			})
			.catch((err) => {
				reject(err);
			});

	});
}

function initializePopupButtons() {
	var overlay = document.querySelector('.inveterate-overlay');
	var openPopupButtons = document.querySelectorAll('.info');
	var closeButtons = document.querySelectorAll('.inveterate-close');

	openPopupButtons.forEach(function (button) {
		button.addEventListener('click', openPopup);
	});

	closeButtons.forEach(function (button) {
		button.addEventListener('click', closePopup);
	});

	overlay.addEventListener('click', closePopup);
}

function openPopup() {
	var popup = document.querySelector('.inveterate-popup');
	var overlay = document.querySelector('.inveterate-overlay');
	popup.style.display = 'block';
	overlay.style.display = 'block';
	document.querySelector('body').classList.add('no-scroll');
}

function closePopup() {
	var popup = document.querySelector('.inveterate-popup');
	var overlay = document.querySelector('.inveterate-overlay');
	popup.style.display = 'none';
	overlay.style.display = 'none';
	document.querySelector('body').classList.remove('no-scroll');
}

function initButton() {
	const vipElements = document.querySelectorAll('.rebuy-cart__flyout-content .add-vip');
	console.log(vipElements);
	if (vipElements.length > 0) {
		vipElements.forEach(function (element) {
			element.addEventListener('click', function (event) {
				document.querySelector('.add-vip').classList.add('loading');
				window.Rebuy.Cart.fetchShopifyCart(cart => {
					if (window.Rebuy.Cart.cartHasSubscriptionItems() === false) {
						addVip(event);
					} else {
						document.querySelector('.add-vip').classList.remove('loading');
						document.getElementById('inveterate_switcher').checked = true;
						alert('You already have a subscription item in your cart. Please remove it before adding another one.');
					}
				});
			})
		});
	}
}
document.addEventListener('DOMContentLoaded', function () {
	initializePopupButtons();
});
